export class AlertsFetcher {
    constructor(patientId, urls) {
        this.patientId = patientId;
        this.urls = urls;
    }
    async fetch() {
        const response = await fetch(`${this.urls.api}patient/alerts/${this.patientId}`, {
            credentials: "include"
        });
        if (!response.ok)
            throw new Error("Error fetching alerts");
        return (await response.json()).result;
    }
}
